import  request from '@/utils/request-utils'
import { appConfig } from '@/config/app-config';
const evnUrl = appConfig.domain.httpUrl

export * from './enum'

/**
 * get 请求 获取所有目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getLocationClassAllService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/location/catalogue/tree'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 添加定位目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const addLocationClassService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/catalogue/add'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 修改目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const updateLocationClassService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/catalogue/edit'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 升级目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const upgradeLocationClassService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/knowledge/equipment/classification/upgrade'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 删除目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const delLocationClassService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/catalogue/delete'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 移动目录
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const locationTypeMoveService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/catalogue/move'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * get 请求 查询定位列表
 * @param formData
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getLocationListService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/location/location/page?catalogueId='+params.catalogueId+'&name='+params.name+'&size='+params.displayNumber+'&page='+params.currentPage))
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 添加定位
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const addLocationListService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/location/add'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 编辑定位
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const editLocationListService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/location/update'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 删除定位
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const delLocationListService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/location/delete'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 转移定位
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const moveLocationListService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/location/location/move'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * get 请求 查询定位列表混合数据
 * @param formData
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getLocationMixListService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/location/location/stationLocation/list?id='+params.id))
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
